"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryContainer = exports.GALLERY_MAX_THUMBNAIL_COUNT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _usePrevious = require("b2b-components/hooks/usePrevious");
var _Gallery = require("../Gallery");
var _useRemoveMagicZoomFromDOM = require("../hooks/useRemoveMagicZoomFromDOM");
var _ = require("../");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GALLERY_MAX_THUMBNAIL_COUNT = exports.GALLERY_MAX_THUMBNAIL_COUNT = 9;
const GalleryContainer = props => {
  (0, _useRemoveMagicZoomFromDOM.useRemoveMagicZoomFromDOM)();
  const {
    image360,
    images,
    videos
  } = props;
  const totalImageCount = images?.length || 0;
  const totalImage360Count = image360 ? 1 : 0;
  const totalVideoCount = videos?.length || 0;
  const totalItemCount = totalImageCount + totalImage360Count + totalVideoCount;
  const itemIndexArray = Array.from(Array(totalItemCount).keys());
  const itemTypeArray = [...Array(totalImageCount).fill(_.GALLERY_ITEM_TYPE.image), ...Array(totalImage360Count).fill(_.GALLERY_ITEM_TYPE.image360), ...Array(totalVideoCount).fill(_.GALLERY_ITEM_TYPE.video)];
  const [currentItemIndex, setCurrentItemIndex] = (0, _react.useState)(0);
  const [currentItemType, setCurrentItemType] = (0, _react.useState)(itemTypeArray[0]);
  const [currentPreviewItemIndex, setCurrentPreviewItemIndex] = (0, _react.useState)(0);
  const [isModalOpened, setIsModalOpened] = (0, _react.useState)(false);
  const prevItemIndex = (0, _usePrevious.usePrevious)(currentItemIndex);
  const handleItemChange = itemIndex => {
    const newItemType = itemTypeArray[itemIndex];
    if ((typeof itemIndex === 'number' || typeof itemIndex === 'string') && newItemType) {
      setCurrentItemIndex(itemIndex);
      setCurrentItemType(newItemType);
    }
  };
  const handlePreviewItemChange = itemIndex => {
    const newItemType = itemTypeArray[itemIndex];
    if (newItemType) {
      setCurrentItemIndex(itemIndex);
      setCurrentItemType(newItemType);
      setCurrentPreviewItemIndex(itemIndex);
    }
  };
  const handlePreviewItemClick = e => {
    e.preventDefault();
    const newItemType = itemTypeArray[currentPreviewItemIndex];
    if (newItemType) {
      setCurrentItemIndex(currentPreviewItemIndex);
      setCurrentItemType(newItemType);
      setIsModalOpened(true);
    }
  };
  const handleMobileMenuItemClick = itemType => e => {
    e.preventDefault();
    //fix for magic toolbox in mobiles - after change section on mobiles, zoom didn't disappear
    window.MagicZoom?.refresh();
    setCurrentItemIndex(itemTypeArray.indexOf(itemType));
    setCurrentItemType(itemType);
  };
  const handleModalClose = () => {
    setIsModalOpened(false);

    // fix for magic toolbox in mobiles - after close of lightbox zoom didn't disappear
    if (window?.mzIsZoomed) {
      window.MagicZoom?.refresh();
      window.mzIsZoomed = false;
    }
  };
  const handleModalKeyDown = event => {
    const key = event.key;
    if (key === 'ArrowLeft' || key === 'Left') {
      const index = currentItemIndex - 1 < 0 ? itemIndexArray.length - 1 : currentItemIndex - 1;
      const newItemType = itemTypeArray[index];
      if (newItemType) {
        setCurrentItemIndex(index);
        setCurrentItemType(newItemType);
      }
    }
    if (key === 'ArrowRight' || key === 'Right') {
      const index = currentItemIndex + 1 >= itemIndexArray.length ? 0 : currentItemIndex + 1;
      const newItemType = itemTypeArray[index];
      if (newItemType) {
        setCurrentItemIndex(index);
        setCurrentItemType(newItemType);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Gallery.Gallery, (0, _extends2.default)({}, props, {
    currentItemIndex: currentItemIndex,
    currentItemType: currentItemType,
    currentPreviewItemIndex: currentPreviewItemIndex,
    itemIndexArray: itemIndexArray,
    isModalOpened: isModalOpened,
    onItemChange: handleItemChange,
    onMobileMenuItemClick: handleMobileMenuItemClick,
    onModalClose: handleModalClose,
    onModalKeyDown: handleModalKeyDown,
    onPreviewItemChange: handlePreviewItemChange,
    onPreviewItemClick: handlePreviewItemClick,
    prevItemIndex: prevItemIndex || 0,
    totalImage360Count: totalImage360Count,
    totalImageCount: totalImageCount,
    totalItemCount: totalItemCount,
    totalVideoCount: totalVideoCount
  }));
};
exports.GalleryContainer = GalleryContainer;
//# sourceMappingURL=GalleryContainer.js.map